import { canUseWindow } from '@library/environment'
import { useEffect, useState } from 'react'

export const DeviceType = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
}

const getDeviceType = (): string => {
  if (!canUseWindow()) {
    return DeviceType.DESKTOP
  }
  const width = window.innerWidth
  let deviceType = DeviceType.DESKTOP
  if (width < 768) {
    deviceType = DeviceType.MOBILE
  } else if (width < 1025) {
    deviceType = DeviceType.TABLET
  }

  return deviceType
}

export const useDeviceType = (): string => {
  const [deviceType, setDeviceType] = useState(getDeviceType())

  useEffect(() => {
    if (canUseWindow()) {
      const onResize = () => {
        setDeviceType(getDeviceType())
      }
      window.addEventListener('resize', onResize)

      return () => {
        window.removeEventListener('resize', onResize)
      }
    }
  }, [])

  return deviceType
}
